import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { ApiService } from '../api.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  email: any;


  constructor(
    private apiService: ApiService,
    private route: Router,
    private viewportScroller: ViewportScroller
  ) { }

  ngOnInit(): void {
  }


  goToLanding() {

    this.route.navigate(['']);
  }

  goToService() {
    window.location.href = '/#AnchorId';
    // this.route.navigateByUrl('/landing#AnchorID');
    // this.router.navigate(['landing'], { fragment: 'AnchorID' });
  }

  goToAbout() {
    this.route.navigate(['about-us']);
  }


  goToFaq() {
    this.route.navigate(['faq']);
  }

  goToTnc(){
    //this.route.navigate(['tnc']);
    window.open('https://lineclearexpress.com/doc/Terms_and_Conditions.pdf', '_blank');
  }

  goToPrivacyPolicy(){
    // this.route.navigate(['privacy_policy']);
     window.open('https://lineclearexpress.com/doc/privacy_policy.pdf', '_blank');
   }

  public onClick(elementId: string): void {

    this.viewportScroller.scrollToAnchor(elementId);

    //   window.location.href = '/v2/landing#AnchorId';
  }

  public goToFragment(fragment: string): void {

    // let elementId = 'serviceId'

    // this.route.navigate( ['/landing#'], {fragment: fragment});
    // this.route.navigate(['/landing#'], { fragment: 'serviceId' });
    // this.route.navigate(['/landing#'+fragment])
    // this.redirectTo('/landing#serviceId');
    // window.location.href = '/v2/landing#' + fragment;
    // window.location.href = '/landing#' + fragment;
    // window.location.href = 'https://lineclearexpress.com/v2/landing#serviceId'
    // window.location.replace("http://someUrl.com");
    // this.viewportScroller.scrollToAnchor(elementId);

    // production
    // this.route.navigateByUrl("/v2/landing#serviceId")

    // staging 
    this.route.navigateByUrl("/#serviceId")

  }





  createContact() {
    console.log('rmail', this.email);
    let data = {
      "updateEnabled": false,
      "email": this.email,
      "listIds": [18]
    }

    this.apiService.newSubscribe(data).subscribe((res: any) => {
      Swal.fire("Success Subscribe", "", "success")
      // console.log('response: ', res)
     // console.clear();

    }, error => {
      // console.log('response: ', error)
      //console.clear();
      let pattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$");
      let valid = pattern.test(this.email);
      if (this.email == null || valid == false){
        Swal.fire("Please enter email.", "", "warning")
      }
      else{
        Swal.fire("Success Subscribe", "", "success")
        this.email = ''
      }
      
    })


  }

}